import { newsFeed } from "@/mocks/feeds";
import { topicTags } from "@/mocks/topics";
import type { Notice } from "@/pages/home/types";
import SectionHeading from "@/pages/home/components/SectionHeading";

interface NewsSectionProps {
  activeTopic: string;
  onOpenNotice: (notice: Notice) => void;
}

export default function NewsSection({ activeTopic, onOpenNotice }: NewsSectionProps) {
  const currentTag = topicTags.find((tag) => tag.id === activeTopic);
  const list = activeTopic === "all" ? newsFeed : newsFeed.filter((item) => item.topic === activeTopic);

  const handleOpen = (item: (typeof newsFeed)[number]) => {
    onOpenNotice({
      title: item.title,
      lines: [
        item.excerpt,
        `标签：${item.tag} · 热度 ${item.heat} · ${item.time} · ${item.comments} 条讨论`,
        "本页为入口导航站，内容为演示用静态摘要，点击不会跳转到站外页面。",
      ],
      copyText: "51heilian01.top",
      copyLabel: "复制入口地址",
    });
  };

  return (
    <section id="news" className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <SectionHeading
          eyebrow="DAILY FEED"
          title="今日瓜讯 · 短讯流"
          desc={`当前筛选：${currentTag ? currentTag.label : "全部话题"}，共 ${list.length} 条；短讯与封面卡片并行呈现，一眼扫完全天动态。`}
          icon="ri-newspaper-line"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {list.map((item) => (
            <article
              key={item.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
              onClick={() => handleOpen(item)}
            >
              <div className="relative h-44 w-full overflow-hidden">
                <img
                  src={item.cover}
                  alt={`${item.title} - 51黑料网今日瓜讯封面`}
                  title={`${item.title} 51黑料网 最新地址`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-md bg-primary-500 px-2.5 py-1 text-[11px] font-bold text-background-50">
                  {item.tag}
                </span>
                <span className="absolute bottom-3 right-3 flex items-center gap-1 rounded-md bg-foreground-950/70 px-2 py-1 text-[11px] font-medium text-background-50">
                  <i className="ri-fire-fill text-accent-400"></i>
                  {item.heat}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4">
                <h3 className="text-sm font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-base">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {item.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {item.time}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {item.comments}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 py-16 text-center">
            <i className="ri-inbox-archive-line text-3xl text-foreground-400"></i>
            <p className="mt-3 text-sm text-foreground-600">该话题暂无可展示的短讯，换个标签看看。</p>
          </div>
        ) : null}
      </div>
    </section>
  );
}